import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "gatsby-plugin-intl";
import { Button, Icon, Header } from "semantic-ui-react";
import HardLink from "./HardLink";
import { PICPICK_DISCOUNT, IS_BLACKFRIDAY } from "../constants";

export const LandingBanner = ({ intl, showButton, landing }, { isMobile }) => {
  if (intl.locale === "ko" || !PICPICK_DISCOUNT) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: IS_BLACKFRIDAY ? "#db2828" : "#f2711c",
        padding: "1.5em",
        display: "flex",
        justifyContent: "center",
        flexDirection: "row",
      }}
    >
      <div style={{ marginRight: "2em" }}>
        <Header as="h1" textAlign="center" size="huge">
          <span className="color-white">
            {IS_BLACKFRIDAY
              ? "BLACK FRIDAY"
              : intl.formatMessage({ id: "text_limitedtimeoffer" })}{" "}
            -{" "}
          </span>
          <span className="color-white">UP TO 20% OFF</span>
        </Header>
        <p style={{ color: "white" }}>
          <Icon name="clock outline" />
          {intl.formatMessage({ id: "promotion_timeout" })}
        </p>
      </div>
      {showButton && (
        <Button
          inverted
          color="white"
          icon="cart"
          size={isMobile ? "big" : "huge"}
          as={HardLink}
          name="buy"
          to="/buy"
          fluid={isMobile}
          style={{ margin: 5 }}
          content={intl.formatMessage({ id: "nav_buy" })}
        />
      )}
    </div>
  );
};

LandingBanner.contextTypes = {
  isMobile: PropTypes.bool,
};

export default injectIntl(LandingBanner);
